import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import S3Upload from "./S3Upload";
import axios from "axios";
import "./media.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

const S3MediaList = () => {
  let [user] = useState(JSON.parse(localStorage.getItem("user")));
  const [media, setMedia] = useState([]);
  const [pages, setPages] = useState({ page: 1, size: 20 });
  const [paging, setPaging] = useState(true);

  const mediaobject = (item) => {
    switch (item.file_type) {
      case "video/mp4":
        return (
          <video className="thumbnail" controls alt={item.link}>
            <source
              src={`${localStorage.getItem("baseimageurl")}/media/${item.link}`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        );
      case "image/jpeg":
        return (
          // <img
          //   className="thumbnail"
          //   src={`${localStorage.getItem("baseimageurl")}/media/${item.link}`}
          //   alt={item.link}
          // />
          <LazyLoadImage
            className="thumbnail"
            src={`${localStorage.getItem("baseimageurl")}/media/${item.link}`}
            alt={item.link}
          />
        );
      case "image/png":
        return (
          <LazyLoadImage
            className="thumbnail"
            src={`${localStorage.getItem("baseimageurl")}/media/${item.link}`}
            alt={item.link}
          />
        );
      case "audio/mpeg":
        return (
          <audio className="thumbnail" controls alt={item.link}>
            <source
              src={`${localStorage.getItem("baseimageurl")}/media/${item.link}`}
              type="audio/mpeg"
            />
            Your browser does not support the audio tag.
          </audio>
        );
      default:
        return <span>---</span>;
    }
  };

  const formatSize = (bytes) => {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  };

  const handleAction = async (e) => {
    e.preventDefault();
    let user = JSON.parse(localStorage.getItem("user"));
    await axios
      .post(
        localStorage.getItem("basurl") + "/" + e.target.dataset.name,
        {
          id: e.target.dataset.id,
          type: e.target.dataset.type,
        },
        {
          headers: {
            "mojo-access-tokens": user.token,
          },
        }
      )
      .then((response) => {
        //console.log(response.data.message);
        e.target.remove();
        axios
          .get(localStorage.getItem("basurl") + "/media-list", {
            headers: {
              "mojo-access-tokens": user.token,
            },
          })
          .then((response) => {
            setMedia(() => {
              return response.data;
            });
          })
          .catch((error) => {
            console.log(error);
          });
        if (e.target.dataset.link) {
          user.profile_pic = e.target.dataset.link;
          document
            .getElementById("profile_pic")
            .setAttribute(
              "src",
              localStorage.getItem("baseimageurl") +
                "/media/" +
                user.profile_pic
            );
          localStorage.setItem("user", JSON.stringify(user));
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  const nextPage = () => {
    loadPaging(pages.page + 1, pages.size);
    setPages((prevState) => {
      return {
        ...prevState,
        page: prevState.page + 1,
      };
    });
  };

  const loadPaging = async (page, size = pages.size) => {
    let user = JSON.parse(localStorage.getItem("user"));
    try {
      await axios
        .get(
          localStorage.getItem("basurl") +
            "/media-list?page=" +
            page +
            "&size=" +
            size,
          {
            headers: {
              "mojo-access-tokens": user.token,
            },
          }
        )
        .then((response) => {
          setMedia((prevState) => {
            prevState.push.apply(prevState, response.data);
            return response.data;
            //return [...prevState]
          });
          if (response.data.length < size) {
            setPaging(false);
          }
        })
        .catch((error) => {
          if (
            typeof error.response.data !== undefined &&
            error.response.data.loginRequired
          ) {
            localStorage.removeItem("user");
            window.location.href = "/login";
          }
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadPaging(1);
  }, []);

  return (
    <>
      <div className="card shadow-base bd-0 mg-4">
        <S3Upload pagetitle="S3 Media" />
      </div>
      <div className="card shadow-base bd-0 mg-4">
        <table className="table table-responsive mg-b-0 tx-12">
          <tbody>
            {media.length ? (
              media.map((item) => (
                <tr key={item.id}>
                  <td className="pd-l-20 valign-middle">{mediaobject(item)}</td>
                  <td className="valign-middle">
                    {user.isadmin === 1 ? (
                      <span className="tx-10 tx-medium d-block">
                        {item.createdby}: {item.city} ({item.state})
                      </span>
                    ) : (
                      ""
                    )}
                    <span className="tx-14 tx-medium ">{item.media_title}</span>
                    <span className="tx-11 d-block">
                      <span className="square-8 bg-success mg-r-5 rounded-circle" />
                      {formatSize(item.file_size)} at{" "}
                      {formatSize(item.upload_speed)}/Sec
                    </span>
                    {/* </td>
                                    <td className="valign-middle"> */}
                    <span className="tx-success">
                      <Moment date={item.created_at1} local fromNow />
                    </span>
                  </td>
                  <td className="valign-middle tx-center">
                    <div className="tx-bold tx-20">
                      <span
                        className=" tx-20 ion-trash-b pointer"
                        onClick={handleAction}
                        data-name="remove"
                        data-type="media"
                        data-id={item.id}
                        title="Remove this media file?"
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="tx-center">
                  You have not uploaded any file yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="card-footer tx-10 pd-y-15 bg-transparent tx-center">
          {paging ? (
            <h4 onClick={nextPage} href="#" className="pointer tx-16">
              <i className="fa fa-angle-down mg-r-5" />
              View More
            </h4>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default S3MediaList;
